import ArticleForm from "@features/creation/articles/components/ArticleForm";
import { ROUTES } from "@features/creation/config/constants";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft, FileEdit } from "lucide-react";

export const Route = createFileRoute("/_app/creation/articles/$id/edit")({
  loader: requirePermission(PERMISSIONS.CREATION.ARTICLES.EDIT),
  staticData: {
    title: "Modifier l'article",
    icon: FileEdit,
    permission: PERMISSIONS.CREATION.ARTICLES.EDIT,
    section: "Creation",
    showInBreadcrumb: true,
  },
  component: EditArticlePage,
});

function EditArticlePage() {
  const { id } = Route.useParams();
  return (
    <div className="max-w-5xl mx-auto">
      {/* Header with back button */}
      <div className="flex items-center gap-4 mb-6">
        <Link
          to={ROUTES.CREATION.ARTICLES.LIST}
          className="btn btn-ghost btn-sm btn-square"
          title="Retour à la liste"
        >
          <ArrowLeft className="w-5 h-5" />
        </Link>
        <div>
          <h1 className="text-2xl font-bold">Modifier l'article</h1>
          <p className="text-sm text-base-content/60">Modifier les informations de l'article</p>
        </div>
      </div>
      <ArticleForm articleId={Number(id)} />
    </div>
  );
}
